const PAGES_DATA = [
  {
    id: 'first-page',
    title: 'First Page',
    description: 'Incididunt adipisicing culpa est sit sint. Quis dolor ipsum quis Lorem nisi nisi ullamco voluptate officia officia aliquip. Ad do cillum reprehenderit aute Lorem Lorem non.',
    url: 'https://example.com',
    technologies: ['HTML', 'SCSS', 'JavaScript', 'PHP']
  },
  {
    id: 'second-page',
    title: 'Second Page',
    description:
      'Qui laborum incididunt magna eu ex. Ea duis voluptate pariatur incididunt nulla voluptate eiusmod et est ex laboris occaecat cupidatat. Ullamco sint minim sint. ',
    url: 'https://example.com',
    technologies: ['HTML', 'SCSS', 'JavaScript', 'PHP']
  },
  {
    id: 'third-page',
    title: 'Third Page',
    description: 'Incididunt adipisicing culpa est sit sint. Quis dolor ipsum quis Lorem nisi nisi ullamco voluptate officia officia aliquip. Ad do cillum reprehenderit aute Lorem Lorem non.',
    url: 'https://example.com',
    technologies: ['HTML', 'SCSS', 'JavaScript', 'PHP']
  },
  {
    id: 'fourth-page',
    title: 'Fourth Page',
    description:
      'Qui laborum incididunt magna eu ex. Ea duis voluptate pariatur incididunt nulla voluptate eiusmod et est ex laboris occaecat cupidatat. Ullamco sint minim sint. ',
    url: 'https://example.com',
    technologies: ['HTML', 'SCSS', 'JavaScript', 'PHP']
  },
  {
    id: 'fiveth-page',
    title: 'Fiveth Page',
    description: 'Incididunt adipisicing culpa est sit sint. Quis dolor ipsum quis Lorem nisi nisi ullamco voluptate officia officia aliquip. Ad do cillum reprehenderit aute Lorem Lorem non.',
    url: 'https://example.com',
    technologies: ['HTML', 'SCSS', 'JavaScript', 'PHP']
  },
  {
    id: 'sixth-page',
    title: 'Sixth Page',
    description:
      'Qui laborum incididunt magna eu ex. Ea duis voluptate pariatur incididunt nulla voluptate eiusmod et est ex laboris occaecat cupidatat. Ullamco sint minim sint. ',
    url: 'https://example.com',
    technologies: ['HTML', 'SCSS', 'JavaScript', 'PHP']
  },
]

export default PAGES_DATA